module.exports = __webpack_public_path__ + "8fca6dfcce6bef3255e7026d3c71baec.svg";